import { render, staticRenderFns } from "./AvancesView.vue?vue&type=template&id=474471bc&"
import script from "./AvancesView.vue?vue&type=script&lang=js&"
export * from "./AvancesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports